import React from "react";
import { TextLinkTemplate } from "./TextLinkTemplate.tsx";
import { MuiFontSizeParam } from "../../types/muiTypes.ts";

interface LinkToCinemaSelectPageProps {
  leadText: string;
  appendHref: boolean;
  fontSizeParam?: MuiFontSizeParam;
}

export const LinkToCinemaSelectPage: React.FC<LinkToCinemaSelectPageProps> = ({
  leadText,
  appendHref,
  fontSizeParam = { xs: "medium", md: "x-large" },
}) => {
  const linkText = "Search for other locations here";
  const link = "/cinema-select";

  return (
    <TextLinkTemplate
      leadText={leadText}
      linkText={linkText}
      href={link}
      appendHref={appendHref}
      fontSizeParam={fontSizeParam}
    />
  );
};
